export default "__VITE_ASSET__C7xsDEf0__"